import type { ProjectContentData } from '../types';
import { PROJECT_CONTENT_TAB_TYPE } from '../types';
import { tableOfContentTab } from './data';

export const earnM: ProjectContentData = {
  id: 'earnm',
  tabs: [
    {
      id: 'description',
      label: 'Description',
      type: PROJECT_CONTENT_TAB_TYPE.TABLE_OF_CONTENT,
      content: tableOfContentTab,
    },
    {
      id: 'token-details',
      label: 'Token Details',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'blockchain-network',
          value: 'BASE',
          name: 'Blockchain Network',
          description: (
            <span>
              The blockchain network
              <br />
              where EARN’M tokens
              <br />
              are issued.
            </span>
          ),
        },
        {
          id: '$EARNM',
          value: '$EARNM',
          name: 'Token Ticker',
          description: (
            <span>
              The symbol representing
              <br />
              the token on exchanges.
            </span>
          ),
        },
        {
          id: 'total-supply',
          value: '5,000,000,000',
          name: 'Total Supply',
          description: (
            <span>
              The total number of
              <br />
              EARN’M tokens that will
              <br />
              ever exist.
            </span>
          ),
        },
        {
          id: 'initial-circulation-supply',
          value: '363,000,000',
          name: 'Initial Circulating Supply',
          description: (
            <span>
              The number of EARN’M
              <br />
              tokens that will be
              <br />
              available at TGE.
            </span>
          ),
        },
        {
          id: 'initial-market-cap',
          value: '$3,630,000',
          name: 'Initial Market Cap',
          description: (
            <span>
              The market value of
              <br />
              circulating tokens at
              <br />
              TGE.
            </span>
          ),
        },
      ],
    },
    {
      id: 'deal-terms',
      label: 'Deal Terms',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'total-raising-goal',
          name: 'Total Raising Goal',
          value: '$50,000',
          description: (
            <span>
              The total amount
              <br />
              EARN’M aims to raise
              <br />
              through the IDO.
            </span>
          ),
        },
        {
          id: 'ido-price',
          name: 'IDO Price',
          value: '$0.010',
          description: (
            <span>
              The price per EARN’M
              <br />
              token during the IDO.
            </span>
          ),
        },
        {
          id: 'deposit-method',
          name: 'Accepted Payment',
          value: 'USDT (BEP20)',
          description: (
            <span>
              The type of
              <br />
              cryptocurrency accepted
              <br />
              for participating in the IDO.
            </span>
          ),
        },
        {
          id: 'claim-method',
          name: 'Refund Policy',
          value: '24 Hours',
          description: (
            <span>
              The time frame in which
              <br />
              you can request a refund
              <br />
              from TGE.
            </span>
          ),
        },
      ],
    },
    {
      id: 'vesting',
      label: 'Vesting',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      layout: 4,
      content: [
        {
          id: 'tge',
          value: '15%',
          name: 'At TGE',
          description: (
            <span>
              The percentage of tokens
              <br />
              available for distribution
              <br />
              at TGE.
              <br />
            </span>
          ),
        },
        {
          id: 'cliff',
          value: '2 months',
          name: 'Cliff',
          description: (
            <span>
              Months until the next
              <br />
              token distribution post-
              <br />
              TGE.
            </span>
          ),
        },
        {
          id: 'linear-vesting',
          value: '7 months daily',
          name: 'Vesting',
          description: (
            <span>
              The time over which the
              <br />
              remaining tokens will be
              <br />
              released.
            </span>
          ),
        },
        {
          id: 'magic-launchpad',
          value: 'Magic Launchpad',
          name: 'Distribution Method',
          description: (
            <span>
              The platform handling
              <br />
              the token distribution.
            </span>
          ),
        },
      ],
    },
    {
      id: 'ido-schedule',
      label: 'IDO Schedule',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      layout: 3,
      content: [
        {
          id: 'sale-start',
          value: 'December 9th',
          name: 'Sale Start',
          description: (
            <span>
              The starting date of the
              <br />
              public IDO sale.
            </span>
          ),
        },
        {
          id: 'sale-end',
          value: 'December 11th',
          name: 'Sale End',
          description: (
            <span>
              The closing date of the
              <br />
              IDO sale.
            </span>
          ),
        },
        {
          id: 'tge-date',
          name: 'TGE Date',
          value: 'December 12th',
          description: (
            <span>
              The date when the
              <br />
              EARN’M goes live.
            </span>
          ),
        },
      ],
    },
  ],
};
